/**
 * Feed text (listing titles, seller names, prices, URLs) is written by
 * marketplace users. Any of it that goes into an HTML string must pass
 * through here, or a title like `<img src=x onerror=...>` runs on the
 * partner's page. Prefer textContent where the code sets one element.
 */
const ENTITIES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

export function escapeHtml (value: unknown): string {
  if (value === null || value === undefined) return ''
  return String(value).replace(/[&<>"']/g, (c) => ENTITIES[c])
}
